import React from "react";

export const KeyIcon = ({ clipId = "clip0_key", styleName, className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" styleName={styleName} className={className}>
    <g clipPath={`url(#${clipId})`}>
      <path d="M17.7334 16.6667L19.6 16.6667L19.6 18L21.3334 18L21.3334 15.0667C21.6282 15.0667 21.8667 14.8281 21.8667 14.5333C21.8667 14.2386 21.6281 14 21.3334 14L21.3334 13.2C21.6282 13.2 21.8667 12.9615 21.8667 12.6667L22.6667 12.6667C23.4031 12.6667 24 12.0698 24 11.3334C24 10.5969 23.4031 10 22.6667 10L7.64064 10C7.92917 9.50108 8.06459 8.90317 7.97085 8.26568C7.79585 7.08235 6.81462 6.14175 5.62503 6.01569C4.02192 5.8459 2.66665 7.09798 2.66665 8.66672C1.19375 8.66672 1.68736e-07 9.86047 2.33118e-07 11.3334C2.97501e-07 12.8063 1.19375 14 2.66665 14C2.66665 15.5688 4.0208 16.8208 5.62503 16.651C6.81459 16.525 7.79584 15.5844 7.97085 14.4011C8.06565 13.7646 7.93023 13.1656 7.64064 12.6667L15.4667 12.6667C15.4667 12.9615 15.7053 13.2 16.0001 13.2L16.0001 14C15.7053 14 15.4667 14.2386 15.4667 14.5333C15.4667 14.8281 15.7053 15.0667 16.0001 15.0667L16.0001 18L17.7334 18L17.7334 16.6667ZM1.66682 11.3334C1.66682 10.7813 2.11473 10.3334 2.66681 10.3334C3.21889 10.3334 3.93347 11.3334 3.93347 11.3334C3.93347 11.3334 3.21889 12.3334 2.66681 12.3334C2.11473 12.3334 1.66682 11.8854 1.66682 11.3334ZM4.33346 14C4.33346 13.4479 5.33346 12.7334 5.33346 12.7334C5.33346 12.7334 6.33345 13.4479 6.33345 14C6.33345 14.5521 5.88553 15 5.33346 15C4.78138 15 4.33346 14.5521 4.33346 14ZM4.33346 8.66672C4.33346 8.11464 4.78138 7.66672 5.33346 7.66672C5.88553 7.66672 6.33345 8.11464 6.33345 8.66672C6.33345 9.21879 5.33346 9.93338 5.33346 9.93338C5.33346 9.93338 4.33346 9.21879 4.33346 8.66672Z" fill="#FF2626"/>
    </g>
    <defs>
      <clipPath id={clipId}>
        <rect width="24" height="24" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export const GoToTopIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 19V5M12 5L5 12M12 5L19 12"
      stroke="#242424"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BrandIcon = ({ category, isMobile }) => {
  const categoryLabels = { bu: "BU", ex: "EX", m: "M" };
  const fontSize = isMobile ? "12px" : "14px";
  
  return (
    <span style={{ 
      width: isMobile ? 36 : 48,
      height: isMobile ? 36 : 48,
      backgroundColor: "var(--red)",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      fontWeight: "bold",
      fontSize
    }}>
      {categoryLabels[category] || "BU"}
    </span>
  );
};
